import api from "./api";

// Fisher-Yates shuffle algorithm
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const getEstablishments = async () => {
    try {
        const response = await api.get(`/establishments?populate=*`);
        // console.log(response.data.data);
        return shuffleArray([...response.data.data]);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getSingleEstablishment = async (id) => {
    try {
        const response = await api.get(`/establishments/${id}?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};

export const getFilteredEstablishments = async (filters = {}, page = 1, pageSize = 12) => {
    try {
        const queryParams = {
            populate: '*',
            filters: {},
            pagination: {
                page,
                pageSize
            }
        };

        // Add price filter if provided
        if (filters.price) {
            queryParams.filters.price = {
                $eq: filters.price
            };
        }

        // Add city filter if provided
        if (filters.city) {
            queryParams.filters.city = {
                $eq: filters.city
            };
        }

        // Add category filter if provided
        if (filters.category) {
            queryParams.filters.category = {
                id: {
                    $eq: filters.category
                }
            };
        }

        // Add search term if provided
        if (filters.search) {
            queryParams.filters.$or = [
                {
                    name: {
                        $containsi: filters.search
                    }
                },
                {
                    description: {
                        $containsi: filters.search
                    }
                }
            ];
        }

        // Add sorting if provided
        if (filters.sort) {
            queryParams.sort = [filters.sort];
        }

        const response = await api.get('/establishments', { params: queryParams });
        const responseData = shuffleArray([...response.data.data]);
        return {
            data: responseData,
            pagination: response.data.meta.pagination
        };
    } catch (e) {
        console.error(e);
        return {
            data: [],
            pagination: {
                page: 1,
                pageSize: pageSize,
                pageCount: 0,
                total: 0
            }
        };
    }
};